import * as React from 'react';

import styled, { css } from 'styled-components';

interface SliderArrowIconProps {
  className?: string;
  arrowDirection?: 'left' | 'right';
  disabled?: boolean;
  circularBg?: boolean;
  onClick: () => void;
}

export const SliderArrowIcon: React.FC<SliderArrowIconProps> = ({
  className,
  arrowDirection,
  disabled,
  circularBg,
  onClick,
}) => {
  return (
    <SvgWrapper
      className={className}
      x="0"
      y="0"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      onClick={onClick}
      disabled={disabled}
    >
      {circularBg ? (
        <Circle cx="20" cy="20" r="20" />
      ) : (
        <Background d="M36 40H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h32c2.2 0 4 1.8 4 4v32C40 38.2 38.2 40 36 40z" />
      )}
      <Path
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d={arrowDirection === 'left' ? 'M22,16l-4,4l4,4' : 'M18 24l4-4 -4-4'}
      />
    </SvgWrapper>
  );
};

export default SliderArrowIcon;

const SvgWrapper = styled.svg<{ disabled?: boolean }>`
  cursor: pointer;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          opacity: 0.5;
        `
      : null}
`;

const Background = styled.path<{ circularBg?: boolean }>`
  opacity: 0.05;
  fill: ${({ theme }) => theme.colors.primaryHover};
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.01;
  }

  ${({ circularBg }) =>
    circularBg
      ? css`
          border-radius: 50%;
        `
      : null}
`;

const Path = styled.path`
  stroke: ${({ theme }) => theme.colors.primary};
`;

const Circle = styled.circle`
  opacity: 0.05;
  fill: ${({ theme }) => theme.colors.primaryHover};
  border-radius: 50%;

  &:hover {
    opacity: 0.01;
  }
`;
